BaseManager = require 'BaseManager'
data = require 'currency'
log = require 'loglevel'


###############################################

class CurrencyManager extends BaseManager

  name: 'CurrencyManager'
  debug: false
  defaults: data.defaults
  locales: data.locales
  currencies: data.currencies

  # -------------------------------------------

  setup: (options) ->
    log.info @name, 'setup', options if @debug

    cc = options.cc.toUpperCase()
    lc = options.lc

    if !cc or cc is ''
      return
    if !lc or lc is ''
      return

    # if de-DE or hu-HU make de or hu
    parts = lc.toLowerCase().split('-')
    if parts[1] and parts[0] == parts[1]
      lc = parts[0]

    format = undefined
    decimal = undefined
    thousand = undefined
    symbol = undefined

    # get the symbol
    symbol = @_lookFor(@currencies.s, cc)

    # attempt to get formatting data for locale
    format = @_lookFor(@locales.f, lc)
    decimal = @_lookFor(@locales.d, lc)
    thousand = @_lookFor(@locales.t, lc)

    # fallback to defaults if we have no data
    if !format
      format = @defaults.format
    if !decimal
      decimal = @defaults.decimal
    if !thousand
      thousand = @defaults.thousand

    # if no symbol use currency code
    if !symbol
      symbol = cc
      # if no format aswell use a different format
      format = @defaults.noSymbolFormat

    @options =
      format: format
      decimal: decimal
      thousand: thousand
      symbol: symbol

    @options

  # -------------------------------------------

  _lookFor: (data, query) ->
    for key, val of data
      for item in val
        return key if item is query
    return false

  # -------------------------------------------

  getCurrencySymbol: ->
    @options.symbol

  # -------------------------------------------

  localize: (amount, remove00 = true, showSymbol = true) ->

    precision = @getPrecision(!remove00,amount)
    res = @formatCurrency(amount, @options, precision, showSymbol)
    res

  # -------------------------------------------

  formatCurrency: (number, opts, precision, showSymbol) ->
    value = @formatNumber(number, opts, precision)
    return value unless showSymbol
    result = opts.format
    result = result.replace('%s', opts.symbol)
    result = result.replace('%v', value)
    result

  # -------------------------------------------

  formatNumber: (number, opts, precision) ->
    usePrecision = precision
    negative = if number < 0 then '-' else ''
    base = parseInt(Math.abs(number or 0).toFixed(usePrecision), 10) + ''
    mod = if base.length > 3 then base.length % 3 else 0
    negative + (if mod then base.substr(0, mod) + opts.thousand else '') + base.substr(mod).replace(/(\d{3})(?=\d)/g, '$1' + opts.thousand) + (if usePrecision then opts.decimal + Math.abs(number).toFixed(usePrecision).split('.')[1] else '')

  # -------------------------------------------

  getPrecision:(showDecimals,amount) ->
    if amount % 1 isnt 0
      return 2

    return 2 if showDecimals
    false

  # -------------------------------------------

module.exports = CurrencyManager.getInstance()


// WEBPACK FOOTER //
// ./coffee/manager/currency-manager.coffee